import { createContext } from 'react';

import { TNewAppraisalFlowRequest, TAppraisalDto } from '@app-velocity/av-api-v2';

import { ErrorWithDetails, SimpleStatus } from '@app-velocity/common';

export type AppraisalVariant = 'dark' | 'light';
export type AppraisalElementLabelSource = 'name' | 'text';

export type AppraisalContextType = {
  reviews: TAppraisalDto[] | null;
  status: SimpleStatus;
  image: string;
  nodeName: string;
  nodeId: string;
  category: TNewAppraisalFlowRequest['method'] | null;
  reviewError?: Error | ErrorWithDetails;
  navigateToElement?: (elementNodeId: string) => void;
  variant?: AppraisalVariant;
  elementLabelSource?: AppraisalElementLabelSource;
};

export const AppraisalContext = createContext<AppraisalContextType>({
  status: 'pending',
  reviews: null,
  category: null,
  nodeName: '',
  nodeId: '',
  image: '',
  variant: 'light',
  elementLabelSource: 'name',
});
